@if (serverError(); as status) {
	<error-page [status]="status" (logout)="logout()"></error-page>
} @else {
	<div class="app">
		<div class="app__container">
			<app-shell-nav
				[items]="menuPoints()"
				[apps]="appNavMenuPoints()"
				[activeApp]="activeApp"
				[environment]="environment"
				[currentUrl]="currentUrl()"
				[navTranslations]="{
					beta: ('general.beta' | translate),
					apps: ('general.apps' | translate),
				}"
				class="hide-mobile"
				(callbackEvent)="navCallback($event)"
			>
			</app-shell-nav>
			<app-shell-mobile-nav
				class="hide-desktop"
				[items]="mobileMenuPoints()"
				[apps]="appNavMenuPoints()"
				[activeApp]="activeApp"
				[environment]="environment"
				[currentUrl]="currentUrl()"
				[navTranslations]="{
					beta: ('general.beta' | translate),
					apps: ('general.apps' | translate),
				}"
				(callbackEvent)="navCallback($event)"
			></app-shell-mobile-nav>
			<div class="app__page">
				<router-outlet></router-outlet>
				@if (error()) {
					<ui-overlay
						(closeOverlay)="onCloseError()"
						[showCloseButton]="true"
						[header]="error().type + '.header' | lowercase | translate"
					>
						<ui-error-content [error]="error()" (closed)="onCloseError()"></ui-error-content>
					</ui-overlay>
				}
			</div>
		</div>
	</div>
	<cookie-overlay></cookie-overlay>
	<toast-container></toast-container>
}
